export interface CallSummaryModel {
    summaryText?: string;
}
